// the items in these two lists have to match up
const newsTypes = ['insight', 'update', 'event']
const archiveFilters = ['insights', 'updates', 'events']

module.exports = {
  newsTypes,
  archiveFilters,
}
